import { DateRangeValue, FilterOption } from './FilterTypes';

export const filterData = (
  data: any,
  filterValues: Record<string, any>,
  filterDefs: FilterOption[]
) => {
  for (const filterId in filterValues) {
    const filterOption = filterDefs.find((f) => f.filterId === filterId);
    const filterValue = filterValues[filterId];
    if (!filterOption || !filterValue) {
      return true;
    }
    const filterType = filterOption.filterType;
    const filterColumn = filterOption.filterId;
    const nodeValue = filterOption.valueModifier
      ? filterOption.valueModifier(data[filterColumn])
      : data[filterColumn];
    if (filterType === 'text') {
      if (!nodeValue?.toLowerCase().includes(filterValue.toLowerCase())) {
        return false;
      }
    }
    if (filterType === 'select') {
      if (Array.isArray(nodeValue)) {
        const values = nodeValue.map((i) =>
          filterOption.selectObjectKey ? i[filterOption.selectObjectKey] : i
        );
        if (!filterValue.some((i) => values.includes(i))) {
          if (
            !(
              filterOption.includeUnassigned &&
              filterValue.includes('unassigned') &&
              !values.length
            )
          )
            return false;
        }
      } else {
        const value = filterOption.selectObjectKey
          ? nodeValue?.[filterOption.selectObjectKey]
          : nodeValue;
        if (!filterValue.includes(value)) {
          if (!(filterOption.includeUnassigned && filterValue.includes('unassigned') && !nodeValue))
            return false;
        }
      }
    }
    if (filterType === 'numberRange') {
      if (
        (filterValue.min && nodeValue < filterValue.min) ||
        (filterValue.max && nodeValue > filterValue.max)
      ) {
        return false;
      }
    }
    if (filterType === 'dateRange') {
      const dateFilterValue = filterValue as DateRangeValue;
      const minDate = dateFilterValue.startDate ? new Date(dateFilterValue.startDate) : null;
      const maxDate = dateFilterValue.endDate ? new Date(dateFilterValue.endDate) : null;
      if (minDate) minDate.setHours(0, 0, 0, 0);
      if (maxDate) maxDate.setHours(23, 59, 59, 999);

      if (Array.isArray(nodeValue)) {
        const dates = nodeValue.map((i) => new Date(i));
        if (
          (!filterOption.includeUnassigned || !dateFilterValue.showUnassigned) &&
          !nodeValue.length
        )
          return false;

        if (dates.length === 1) {
          if ((minDate && dates[0] < minDate) || (maxDate && dates[0] > maxDate)) {
            return false;
          }
        } else if (
          dates.length === 2 &&
          ((minDate && dates[0] < minDate) || (maxDate && dates[1] > maxDate))
        ) {
          return false;
        }
      } else {
        const date = new Date(nodeValue);
        if ((!filterOption.includeUnassigned || !dateFilterValue.showUnassigned) && !nodeValue)
          return false;
        if ((minDate && date < minDate) || (maxDate && date > maxDate)) {
          return false;
        }
      }
    }
  }
  return true;
};
